<div class="session-shell">
  <div class="session-shell__toolbar">
    <app-theme-toggle />
  </div>

  <main class="session-shell__main" id="contenido">
    <router-outlet />
  </main>

  <footer class="session-shell__foot">
    <p>KeyStoreMan · Consola administrativa</p>
  </footer>
</div>
